var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#3642F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.57861 4 4 7.578 4 12C4 13.4032 4.36597 14.7737 5.06091 15.9824L4.03015 19.1833C3.95825 19.4065 4.01733 19.6511 4.18311 19.8169C4.34729 19.9811 4.59131 20.0424 4.81665 19.9698L8.01758 18.9391C9.22632 19.634 10.5968 20 12 20C16.4214 20 20 16.422 20 12C20 7.57861 16.422 4 12 4ZM12 18.75C10.7325 18.75 9.49707 18.3964 8.42712 17.7273C8.27319 17.6311 8.08203 17.6051 7.90417 17.6624L5.59351 18.4065L6.33765 16.0958C6.39404 15.9205 6.37024 15.7291 6.27258 15.5729C5.60364 14.5029 5.25 13.2675 5.25 12C5.25 8.27808 8.27808 5.25 12 5.25C15.7219 5.25 18.75 8.27808 18.75 12C18.75 15.7219 15.7219 18.75 12 18.75ZM12.7812 12C12.7812 12.4314 12.4315 12.7812 12 12.7812C11.5685 12.7812 11.2188 12.4314 11.2188 12C11.2188 11.5685 11.5685 11.2188 12 11.2188C12.4315 11.2188 12.7812 11.5685 12.7812 12ZM15.9062 12C15.9062 12.4314 15.5565 12.7812 15.125 12.7812C14.6935 12.7812 14.3438 12.4314 14.3438 12C14.3438 11.5685 14.6935 11.2188 15.125 11.2188C15.5565 11.2188 15.9062 11.5685 15.9062 12ZM9.65625 12C9.65625 12.4314 9.30652 12.7812 8.875 12.7812C8.4436 12.7812 8.09375 12.4314 8.09375 12C8.09375 11.5685 8.4436 11.2188 8.875 11.2188C9.30652 11.2188 9.65625 11.5685 9.65625 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.aad86c37fc98c732c994fd8fbc6ebb8d.svg";
export { ForwardRef as ReactComponent };